import React from 'react';
import TR from './../../Trans';
import TrackCreators from '../items/TrackCreators';
import Button from '@mui/material/Button';
import BDialog from './BDialog';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

function CreatorsDialog(props) {

  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onClose();
    }
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus open={props.open} onKeyDown={handleKeyDown}  onClose={props.onClose}>
      <DialogContent>
        <p className="muvika-creators-p">
          {TR.cm_title}: {props.track?.title}
        </p>
        <p className="muvika-creators-p">
          {TR.cm_artist}: {props.track?.artist}
        </p>
        <p className="muvika-creators-p">
          {TR.cm_language}: {props.track?.language}
        </p>
        <p className="muvika-creators-p">
          {TR.cm_label}: {props.track?.label}
        </p>
        <TrackCreators creators={props.creators} />
      </DialogContent>
      <DialogActions>
      <Stack direction="row" spacing={6} justifyContent="center">
        <Button color="success" onClick={props.onClose}>Ok</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default CreatorsDialog;